import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { fontFamily, fontSize } from '../../../../constants/text';
import { colors } from '../../../../constants/colors';
import { formatPrice } from '../../../../core/util/string';

const Row = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-top: ${colors.greyDim} 1px solid;
  ${({ highlighted }) => css`
    span {
      color: ${highlighted ? colors.crunchBerry : colors.blueMonday} !important;
    }
  `}

  &:first-child {
    border-top: none;
  }
`;

const Item = styled.span`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
`;

export default class SelfPayRow extends PureComponent {
  static propTypes = {
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    highlighted: PropTypes.bool,
  };

  render() {
    const { price, name, highlighted } = this.props;
    return (
      <Row highlighted={highlighted}>
        <Item>{name}</Item>
        <Item data-testid={`selfPayPrice-${name}`}>{formatPrice(price)}</Item>
      </Row>
    );
  }
}
